import {createRouter, createWebHistory} from "vue-router";
// import Layout from '../layout/index'
// import Home from '../views/Home'
import CreateInterviewStep1 from '../views/CreateInterview/CreateInterviewStep1.vue';
import CreateInterviewStep2 from '../views/CreateInterview/CreateInterviewStep2.vue';
import InterviewPage from '../components/InterviewPage.vue';
import Homepage from '../components/Homepage.vue';
import InterviewCompleted from '../views/CreateInterview/InterviewCompleted.vue';
import userInfo from '../views/UserCenter/UserInfo.vue'; //src\views\UserCenter\UserInfo.vue
import UserAgreement from '../components/UserAgreement.vue'; // 引入用户协议组件
import pay from '../components/pay.vue'; // 引入用户协议组件

export const routerMap = [
    {
        path: '/user-agreement',
        name: 'UserAgreement',
        component: UserAgreement,
    },
    {
        path: '/home',
        name: 'home',
        component: Homepage
    },
    {
        path: '/interview',
        name: 'InterviewPage',
        component: InterviewPage
    },
    {
        path: '/create-interview/step1',
        name: 'CreateInterviewStep1',
        component: CreateInterviewStep1,
    },
    {
        path: '/create-interview/step2',
        name: 'CreateInterviewStep2',
        component: CreateInterviewStep2,
    },
    {
        path: '/interview-completed',
        name: 'InterviewCompleted',
        component: InterviewCompleted
    },
    {
        path: '/userInfo',
        name: 'userInfo',
        component: userInfo
    },
    {
        path: '/pay',
        name: 'pay',
        component: pay
    },
    {
        path: '/401',
        name: '401',
        component: () => import('../views/error/401')
    },
    {
        path: '/404',
        name: '404',
        component: () => import('../views/error/404')
    }
    // ,
    // {
    //     path: '/Layout',
    //     name: 'Layout',
    //     component: Layout,
    //     children: [
    //         {
    //             path: '/home',
    //             name: '官网首页',
    //             component: Home
    //         }
    //     ]
    // }
]

//  创建路由
const routers = createRouter({
    history: createWebHistory(),
    routes: routerMap
})

export default routers